<a [routerLink]="routerLink">
  <div class="d-flex" class="text-bold">
    <fa-icon [icon]="['far', 'chevron-left']" class="me-2"></fa-icon>
    <span>{{ label | translate }}</span>
  </div>
</a>
